import type { ReactNode } from "react";
import { useLocation } from "react-router";

import { AdminVNextShell } from "@/vnext/app-shell/AdminVNextShell";
import { useWorkspaceChromeLogging } from "@/vnext/routes/useWorkspaceChromeLogging";
import {
  NO_WORKSPACE_TABS,
  useAdminNavPageTabStrip,
} from "@/vnext/shared/workspace/useAdminNavPageTabStrip";
import { WorkspaceTabNav } from "@/vnext/shared/workspace/WorkspaceTabNav";
import "@/vnext/shared/workspace/workspaceChrome.css";

interface SettingsWorkspaceChromeProps {
  actions?: ReactNode;
  children: ReactNode;
  subtitle: string;
  title: string;
}

export function SettingsWorkspaceChrome({
  actions,
  children,
  subtitle,
  title,
}: SettingsWorkspaceChromeProps) {
  const location = useLocation();
  // §11 page tabs (e.g. Team, Audits, Access, Logs, Technical team tools)
  // replace the old grouped finder that listed every settings route.
  const strip = useAdminNavPageTabStrip(location.pathname);
  const logTabClick = useWorkspaceChromeLogging({
    activePath: strip?.activePath ?? "",
    componentName: "SettingsWorkspaceChrome",
    pathname: location.pathname,
    tabs: strip?.tabs ?? NO_WORKSPACE_TABS,
    workspaceLabel: "settings",
  });

  return (
    <AdminVNextShell
      actions={actions}
      breadcrumbs={[
        { label: "Dashboard", path: "/dashboard" },
        { label: "Settings and admin" },
        { label: title },
      ]}
      hideWorkspaceSections
      subtitle={subtitle}
      title={title}
    >
      <div className="admin-workspace-page">
        {strip ? (
          <WorkspaceTabNav
            activePath={strip.activePath}
            ariaLabel={strip.ariaLabel}
            onTabClick={logTabClick}
            tabs={strip.tabs}
          />
        ) : null}
        {children}
      </div>
    </AdminVNextShell>
  );
}
